import type { TooltipProps } from '@packages/modules/src/Tooltip/TooltipProps';
import { useSearchParams } from 'next/navigation';
import type { TooltipDataContentSnippetType, TooltipDataPromotionType } from '../../interfaces';
import { createFilterForTimeControl } from '../utils/filterResult';

export const useGetTooltipContent = (
  promotion?: TooltipDataPromotionType,
  contentSnippet?: TooltipDataContentSnippetType,
): TooltipProps['content'] => {
  let tooltipContentSnippet: TooltipProps['content'] | undefined;
  if (contentSnippet) {
    if (Array.isArray(contentSnippet)) {
      tooltipContentSnippet =
        contentSnippet?.find((item) => item.bundle === 'tooltip' && item.field_conditions)
          ?.field_conditions ?? undefined;
    } else if (
      contentSnippet.field_conditions &&
      typeof contentSnippet.field_conditions === 'object'
    ) {
      tooltipContentSnippet = contentSnippet.field_conditions.processed;
    }
  }
  const query = Object.fromEntries(useSearchParams()?.entries() ?? []);
  const { TestDate } = query;
  const filterTime = createFilterForTimeControl(TestDate);

  const tooltipContent =
    promotion?.find((item) => filterTime(item))?.field_promotion_feedback_descrip ??
    tooltipContentSnippet;

  return tooltipContent;
};
